"use client"

import { useState } from "react"
import { FormattedMessage, useIntl } from "react-intl"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Label } from "@/components/ui/label"
import { useToast } from "@/components/ui/use-toast"

import { Textarea } from "./ui/textarea"

export default function ContactUs({
  open,
  setOpen,
}: {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}) {
  const { toast } = useToast()
  const intl = useIntl()

  const [message, setMessage] = useState(
    intl.formatMessage({ id: "contactUs.placeholder" })
  )
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    console.log("handleSubmit")
    e.preventDefault()
    setSubmitting(true)

    // Prepare form data
    const formData = { message }

    // Post request to the API
    const response = await fetch("/api/help/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })

    // Handle response
    setSubmitting(false)
    if (response.ok) {
      toast({
        title: intl.formatMessage({ id: "contactUs.toast.successTitle" }),
        description: intl.formatMessage({
          id: "contactUs.toast.successDescription",
        }),
      })
      setOpen(false)
    } else {
      toast({
        title: intl.formatMessage({ id: "contactUs.toast.errorTitle" }),
        description: intl.formatMessage({
          id: "contactUs.toast.errorDescription",
        }),
        variant: "destructive",
      })
    }
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <form onSubmit={(e) => handleSubmit(e)}>
          <DialogHeader>
            <DialogTitle>
              <FormattedMessage id="contactUs.title" />
            </DialogTitle>
            <DialogDescription>
              <FormattedMessage id="contactUs.description" />
            </DialogDescription>
          </DialogHeader>
          <div>
            {/* Message field */}
            <div className="space-y-2">
              <Label htmlFor="message" className="text-right">
                <FormattedMessage id="contactUs.message" />
              </Label>
              <Textarea
                rows={10}
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="col-span-3"
                placeholder={intl.formatMessage({
                  id: "contactUs.placeholder",
                })}
              />
            </div>
          </div>
          <DialogFooter>
            <Button type="submit">
              {submitting ? (
                <FormattedMessage id="contactUs.submitting" />
              ) : (
                <FormattedMessage id="contactUs.submit" />
              )}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
